const namespace = 'INVESTOR_';

export const CONSTANTS = {
    SET_IS_FETCHING_CONFIG: `${namespace}SET_IS_FETCHING_CONFIG`,
    SET_IS_FETCHING_PORTFOLIO: `${namespace}SET_IS_FETCHING_PORTFOLIO`,
    SET_IS_FETCHING_DEALS: `${namespace}SET_IS_FETCHING_DEALS`,
    SET_IS_FETCHING_PERMISSIONS: `${namespace}SET_IS_FETCHING_PERMISSIONS`,
    SET_PORTFOLIO_SELECTED_FETCH_TYPE: `${namespace}SET_PORTFOLIO_SELECTED_FETCH_TYPE`,
    SET_PORTFOLIO_PAGE_NUMBER: `${namespace}SET_PORTFOLIO_PAGE_NUMBER`,
    SET_SHOW_UPGRADE_TO_SCAN: `${namespace}SET_SHOW_UPGRADE_TO_SCAN`,
    SET_SHOW_REFRESH_REPORT: `${namespace}SET_SHOW_REFRESH_REPORT`,
    SET_AML_PEP_REFRESH_BANNER: `${namespace}SET_AML_PEP_REFRESH_BANNER`,
    SET_REFRESH_REPORT_PRESELECTED_MODULES: `${namespace}SET_REFRESH_REPORT_PRESELECTED_MODULES`,
    SET_COMPANY_LOGO_WEBSITE: `${namespace}SET_COMPANY_LOGO_WEBSITE`,
    SET_ENRICHED_LINKEDIN: `${namespace}SET_ENRICHED_LINKEDIN`,
    SET_SHOW_UNLOCK_AICA_CONFIRMATION: `${namespace}SET_SHOW_UNLOCK_AICA_CONFIRMATION`,
    SET_SHOW_UNLOCK_AICA_AND_ADD_TO_LEADS: `${namespace}SET_SHOW_UNLOCK_AICA_AND_ADD_TO_LEADS`,
    SET_ADD_TO_WATCHLIST_MODAL: `${namespace}SET_ADD_TO_WATCHLIST_MODAL`,
    SET_SHOW_GLOBAL_SEARCH: `${namespace}SET_SHOW_GLOBAL_SEARCH`,
    SET_SHOW_INVITE_USER: `${namespace}SET_SHOW_INVITE_USER`,
    SET_SHOW_INVITE_USER_WITH_CALLBACK: `${namespace}SET_SHOW_INVITE_USER_WITH_CALLBACK`,
    FETCH_SINGLE_COMPANY_DETAILS_SUCCESS: `${namespace}FETCH_SINGLE_COMPANY_DETAILS_SUCCESS`,
    SET_DEAL_DRAWER: `${namespace}SET_DEAL_DRAWER`,
    SET_DEAL_FILTER_DRAWER: `${namespace}SET_DEAL_FILTER_DRAWER`,
    UPDATE_DEAL_STATUS: `${namespace}UPDATE_DEAL_STATUS`,
    UPDATE_DEAL_OWNER: `${namespace}UPDATE_DEAL_OWNER`,
    UPDATE_INVESTOR_DEAL_STATUS: `${namespace}UPDATE_INVESTOR_DEAL_STATUS`,
    UPDATE_COMPANY_STATUS: `${namespace}UPDATE_COMPANY_STATUS`,

    INITIALISE_COMPANIES_LIST_FILTERS_CONFIG: `${namespace}INITIALISE_COMPANIES_LIST_FILTERS_CONFIG`,
    SELECT_COMPANIES_LIST_FILTER_VALUES: `${namespace}SELECT_COMPANIES_LIST_FILTER_VALUES`,
    RESET_COMPANIES_LIST_FILTER_VALUES: `${namespace}RESET_COMPANIES_LIST_FILTER_VALUES`,

    FETCH_INVESTOR_CONFIG: `${namespace}FETCH_INVESTOR_CONFIG`,
    FETCH_LENDER_CONFIG: `${namespace}FETCH_LENDER_CONFIG`,
    FETCH_INVESTOR_CONFIG_SUCCESS: `${namespace}FETCH_INVESTOR_CONFIG_SUCCESS`,

    FETCH_INVESTOR_PERMISSIONS: `${namespace}FETCH_INVESTOR_PERMISSIONS`,
    FETCH_INVESTOR_PERMISSIONS_SUCCESS: `${namespace}FETCH_INVESTOR_PERMISSIONS_SUCCESS`,

    FETCH_PORTFOLIO_DATA: `${namespace}FETCH_PORTFOLIO_DATA`,
    FETCH_PORTFOLIO_DATA_SUCCESS: `${namespace}FETCH_PORTFOLIO_DATA_SUCCESS`,
    FETCH_DEALS_SUCCESS: `${namespace}FETCH_DEALS_SUCCESS`,
    CLEAR_DEALS_DATA: `${namespace}CLEAR_DEALS_DATA`,
    FETCH_SINGLE_COMPANY_DETAILS: `${namespace}FETCH_SINGLE_COMPANY_DETAILS`,
    FETCH_COMPANY_COMMENTS: `${namespace}FETCH_COMPANY_COMMENTS`,
    FETCH_COMPANY_COMMENTS_SUCCESS: `${namespace}FETCH_COMPANY_COMMENTS_SUCCESS`,
    FETCH_MEETING_TRANSCRIPT: `${namespace}FETCH_MEETING_TRANSCRIPT`,

    FETCH_OWNER_DATA: `${namespace}FETCH_OWNER_DATA`,
    FETCH_OWNER_DATA_SUCCESS: `${namespace}FETCH_OWNER_DATA_SUCCESS`,

    INITIATE_REPORT_GENERATION: `${namespace}INTITIATE_REPORT_GENERATION`,
    INITIATE_REPORT_GENERATION_SUCCESS: `${namespace}INTITIATE_REPORT_GENERATION_SUCCESS`,

    INVITE_COMPANY: `${namespace}INVITE_COMPANY`,
    INVITE_COMPANY_V2: `${namespace}INVITE_COMPANY_V2`,
    // INVITE_COMPANY_SUCCESS: `${namespace}INVITE_COMPANY_SUCCESS`

    UPDATE_COMPANY: `${namespace}UPDATE_COMPANY`,
    CREATE_DEAL: `${namespace}CREATE_DEAL`,
    METRICS_FOR_DEAL_CREATION: `${namespace}METRICS_FOR_DEAL_CREATION`,
    PEC_MATCHING: `${namespace}PEC_MATCHING`,
    GET_ALL_DEALS: `${namespace}GET_ALL_DEALS`,
    GET_ALL_LENDER_DEALS: `${namespace}GET_ALL_LENDER_DEALS`,
    GET_SPECIFIC_LENDER_DEALS: `${namespace}GET_SPECIFIC_LENDER_DEALS`,
    GET_DEAL_DATA: `${namespace}GET_DEAL_DATA`,
    GET_LENDER_DEAL_DATA: `${namespace}GET_LENDER_DEAL_DATA`,
    UPDATE_DEAL: `${namespace}UPDATE_DEAL`,
    UPDATE_INVESTOR_DEAL: `${namespace}UPDATE_INVESTOR_DEAL`,
    UPDATE_LENDER_USERS: `${namespace}UPDATE_LENDER_USERS`,
    GET_INVESTMENT_PREFERENCE: `${namespace}GET_INVESTMENT_PREFERENCE`,
    GET_ALL_INVESTMENT_PREFERENCES: `${namespace}GET_ALL_INVESTMENT_PREFERENCES`,
    CREATE_INVESTMENT_PREFERENCE: `${namespace}CREATE_INVESTMENT_PREFERENCE`,
    UPDATE_DEAL_COMMENTS: `${namespace}UPDATE_DEAL_COMMENTS`,
    UPDATE_DEAL_CUSTOM_FIELDS: `${namespace}UPDATE_DEAL_CUSTOM_FIELDS`,
    UPDATE_DEAL_LAST_STATUS_UPDATE_TIME: `${namespace}UPDATE_DEAL_LAST_STATUS_UPDATE_TIME`,
    UPDATE_INVESTMENT_PREFERENCE: `${namespace}UPDATE_INVESTMENT_PREFERENCE`,

    FETCH_TAB_LOCK_STATUS: `${namespace}FETCH_TAB_LOCK_STATUS`,
    FETCH_TAB_LOCK_STATUS_SUCCESS: `${namespace}FETCH_TAB_LOCK_STATUS_SUCCESS`,
    SET_MODULE_POLLING_LIST: `${namespace}SET_MODULE_POLLING_LIST`,
    SET_EXTENDED_POLLING_MODULES: `${namespace}SET_EXTENDED_POLLING_MODULES`,
    SET_TASK_TRACKER_MAP: `${namespace}SET_TASK_TRACKER_MAP`,
    SET_TASK_TRACKER_RESOLVED: `${namespace}SET_TASK_TRACKER_RESOLVED`,
    MERGE_CROSS_MODULE_TASK_TRACKER_CACHE: `${namespace}MERGE_CROSS_MODULE_TASK_TRACKER_CACHE`,
    RESET_TASK_TRACKER_RESOLUTION: `${namespace}RESET_TASK_TRACKER_RESOLUTION`,
    UPDATE_UNTAGGED_MU_FILE_NUMBER: `${namespace}UPDATE_UNTAGGED_MU_FILE_NUMBER`,
    SET_ONE_PAGER_DATA: `${namespace}SET_ONE_PAGER_DATA`,
    CLOSE_ONE_PAGER: `${namespace}CLOSE_ONE_PAGER`,
    SET_ENGAGEMENT_LETTER_DATA: `${namespace}SET_ENGAGEMENT_LETTER_DATA`,
    SET_BUREAU_KYC_CONSENT_DATA: `${namespace}SET_BUREAU_KYC_CONSENT_DATA`,
    SET_NDA_DATA: `${namespace}SET_NDA_DATA`,
    SET_APPLICATION_FORM_DATA: 'SET_APPLICATION_FORM_DATA',
    CLOSE_ENGAGEMENT_LETTER: `${namespace}CLOSE_ENGAGEMENT_LETTER`,
    CLOSE_BUREAU_KYC_CONSENT: `${namespace}CLOSE_BUREAU_KYC_CONSENT`,
    CLOSE_NDA: `${namespace}CLOSE_NDA`,
    CLOSE_APPLICATION_FORM: 'CLOSE_APPLICATION_FORM',
    UPDATE_NEED_INFO_FILE_NUMBER: `${namespace}UPDATE_NEED_INFO_FILE_NUMBER`,
    OPEN_DEAL_APPLICATION_DRAWER: `${namespace}OPEN_DEAL_APPLICATION_DRAWER`,
    UPDATE_DEAL_APPLICATION_DATA: `${namespace}UPDATE_DEAL_APPLICATION_DATA`,
    SET_DEAL_FILTERS: `${namespace}SET_DEAL_FILTERS`,
    RESET_DEAL_FILTERS: `${namespace}RESET_DEAL_FILTERS`,
    SET_SHOW_MANAGE_TEAM_DRAWER: `${namespace}SET_SHOW_MANAGE_TEAM_DRAWER`,
    FETCH_AICA_DEBT_PRODUCT_CONFIG: `${namespace}FETCH_AICA_DEBT_PRODUCT_CONFIG`,

    SET_CUSTOM_FILTER_DRAWER: `${namespace}SET_CUSTOM_FILTER_DRAWER`,
    SET_MOBILE_OVERVIEW_SOURCE: `${namespace}SET_MOBILE_OVERVIEW_SOURCE`,
    SET_COMPOSE_EMAIL_MODAL: `${namespace}SET_COMPOSE_EMAIL_MODAL`,
    SET_CREATE_MANDATE_MODAL: `${namespace}SET_CREATE_MANDATE_MODAL`,
    SET_GENERIC_CONFIRMATION_MODAL: `${namespace}SET_GENERIC_CONFIRMATION_MODAL`,
    SET_DEAL_STATUS_CONFIG: `${namespace}SET_DEAL_STATUS_CONFIG`,
    TRIGGER_REQUIREMENTS_REFRESH: `${namespace}TRIGGER_REQUIREMENTS_REFRESH`,

    // Column Customization
    OPEN_COLUMN_CUSTOMIZATION_DRAWER: `${namespace}OPEN_COLUMN_CUSTOMIZATION_DRAWER`,
    CLOSE_COLUMN_CUSTOMIZATION_DRAWER: `${namespace}CLOSE_COLUMN_CUSTOMIZATION_DRAWER`,
    SET_COLUMN_CUSTOMIZATION_STATE: `${namespace}SET_COLUMN_CUSTOMIZATION_STATE`,
    UPDATE_SELECTED_COLUMNS: `${namespace}UPDATE_SELECTED_COLUMNS`,
    UPDATE_TEMP_SELECTED_COLUMNS: `${namespace}UPDATE_TEMP_SELECTED_COLUMNS`,
    APPLY_COLUMN_CUSTOMIZATION: `${namespace}APPLY_COLUMN_CUSTOMIZATION`,
    RESET_COLUMN_CUSTOMIZATION: `${namespace}RESET_COLUMN_CUSTOMIZATION`,

    FETCH_PARTNER_DATA_SUCCESS: `${namespace}FETCH_PARTNER_DATA_SUCCESS`,
    FETCH_PARTNER_DATA: `${namespace}FETCH_PARTNER_DATA`,
    SET_EDIT_USER_MODAL: `${namespace}SET_EDIT_USER_MODAL`,
    SET_DELETE_USER_MODAL: `${namespace}SET_DELETE_USER_MODAL`,

    FETCH_ORG_INFO: `${namespace}FETCH_ORG_INFO`,
    FETCH_ORG_INFO_SUCCESS: `${namespace}FETCH_ORG_INFO_SUCCESS`,
    FETCH_PLATFORM_USER_DETAILS: `${namespace}FETCH_PLATFORM_USER_DETAILS`,
    SET_PLATFORM_USER_DATA: `${namespace}SET_PLATFORM_USER_DATA`,
    SET_DEAL_TERMS_LOGGING_DRAWER_PREFILLED_STATUS: `${namespace}SET_DEAL_TERMS_LOGGING_DRAWER_PREFILLED_STATUS`,

    SET_LEAD_ARCHIVED: `${namespace}SET_LEAD_ARCHIVED`,

    SET_VIEW_ALL_LEAD_ROW: `${namespace}SET_VIEW_ALL_LEAD_ROW`,
    CLEAR_VIEW_ALL_LEAD_ROW: `${namespace}CLEAR_VIEW_ALL_LEAD_ROW`,
    FETCH_VIEW_ALL_LEAD_ROW: `${namespace}FETCH_VIEW_ALL_LEAD_ROW`,
};

export const AICA_TEXT =
    "The Artificial Intelligence Company Assessment(AICA) Score is a comprehensive scoring system meticulously designed to evaluate the overall health and stability of organizations with a focus on attracting potential investments.\n Using a sophisticated rating scale ranging from 0 to 100, the AICA Score provides valuable insights into an organization's financial robustness and growth potential, aiding investors in making informed decisions.The AICA Score takes into account an array of critical metrics that directly impact an organization's performance and sustainability. These metrics include but are not limited to Revenue, Customer Concentration, Liquidity, Growth, Compliance, and other key performance indicators specific to each organization's industry and nature of operations.Each individual metric is meticulously scored on a scale from 0 to 100, reflecting its relative strength or weakness. The scores for these metrics are then thoughtfully weighed and amalgamated to generate a comprehensive and definitive score for the organization as a whole.\n A score of 0 signifies significant instability and potential risk, while a perfect score of 100 indicates a highly favorable and robust organization. AICA Score serves as an indispensable aid for investors seeking a deeper understanding of an organization's financial standing and resilience before making critical investment decisions. By providing a clear and concise assessment of an organization's strengths and weaknesses, ACIA score empowers investors to identify lucrative opportunities and manage risks effectively in today's dynamic market landscape. Leveraging AICA score, investors can gain a competitive edge by making data-driven investment choices, fostering growth, and partnering with organizations that demonstrate exceptional potential for long-term success.\n Its objective, transparent, and reliable evaluation process ensures that investors can confidently navigate the investment landscape with enhanced precision and confidence.";

export const COMPANIES_LIST_TAB = {
    ALL: 'all',
    NEW: 'new',
    VIEWED: 'viewed',
    MONITORING: 'monitoring',
    NOT_MONITORING: 'notMonitoring',
};

export const TAB_LABELS = {
    ALL_COMPANIES: 'All',
    NEW_COMPANIES: 'New',
    VIEWED_COMPANIES: 'Viewed',
    MONITORING_COMPANIES: 'Monitoring',
    NOT_MONITORING_COMPANIES: 'Not Monitoring',
};

export const DEAL_LIST_TABS = {
    ALL: 'all',
    APPROVED: 'approved',
    PASSED: 'passed',
};

export const ACCESS_TYPES = {
    LOCKED: 'LOCKED',
    TRAIL: 'TRIAL',
    UNLOCKED: 'UNLOCKED',
    HIDDEN: 'HIDDEN',
};

export const MANAGE_USERS_TABS = {
    TEAM: 'Team',
    INVESTOR: 'Investors',
    LENDER: 'Lenders',
    PARTNER: 'Partners',
    COMPANY: 'Assessee',
    ALL_USERS: 'AllUsers',
};

export const BUREAU_TYPE = {
    CIBIL: 'CIBIL',
    EQUIFAX: 'EQUIFAX',
    EXPERIAN: 'EXPERIAN',
};

export const USER_TYPES = {
    LENDER: 'LENDER',
    LENDER_TEAM: 'LENDER_TEAM',
    ADMIN_TEAM: 'ADMIN_TEAM',
    PARTNER_TYPE: 'PARTNER', // This is basically user of the organisation/partner organisation added by PNO under PNO Org
    INVESTOR_TYPE: 'INVESTOR', // can be referred as Investor/PNO
    COMPANY_TYPE: 'ASSESSEE', // can be referred as Borrower/Company/Assessee
    PNO: 'PNO',
};

export const MANAGE_DROPDOWN = {
    MANAGE_TEAM: 'Manage Team',
    MANAGE_PARTNERS: 'Manage Partners',
    MANAGE_INVESTORS: 'Manage Lenders',
};

export const PROFILE_GENERATION_STATUS = {
    UNINITIATED: 'UNINITIATED',
    TAGGED_FOR_GENERATION: 'TAGGED_FOR_GENERATION',
    BUILD_INITIATED: 'BUILD_INITIATED',
    UNINITIATED_MANUAL: 'UNINITIATED_MANUAL',
    COMPLETE: 'COMPLETE',
    LOCKED: 'LOCKED',
};

export const ACCESS_TIERS = {
    SCAN: 'SCAN',
    WATCH: 'WATCH',
    TRACK: 'TRACK',
    DEALS: 'DEALS',
};

export const PORTFOLIO_COMPANY_TYPES = {
    FIND: 'FIND',
    LEADS: 'LEADS',
    DEALS: 'DEALS',
};

export const MAX_LENGTH = {
    CHATBOT_INPUT: 400,
};

export const INVESTOR_ROLES = {
    ALL_ACCESS: 'allAccess',
    RESTRICTED_INVESTOR_ACCESS: 'restrictedInvestorAccess',
    RESTRICTED_UNDERWRITER_ACCESS: 'restrictedUnderwriterAccess',
};

export const RESTRICTED_ROLES = [INVESTOR_ROLES.RESTRICTED_INVESTOR_ACCESS, INVESTOR_ROLES.RESTRICTED_UNDERWRITER_ACCESS];

export enum RiskGrade {
    SEVERE = 'SEVERE',
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
}

export enum MonitoringStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum EngagementLetterStatus {
    NOT_SHARED = 'NOT_SHARED',
    SHARED = 'SHARED',
    SIGNED = 'SIGNED',
}

export enum UnlockAICASourcePage {
    DASHBOARD_SIDEBAR = 'DASHBOARD_SIDEBAR',
    DASHBOARD_HEADER = 'DASHBOARD_HEADER',
    PORTFOLIO = 'PORTFOLIO',
}

export const JOURNEY_NAMES = {
    SUMMON_AICA: 'SUMMON_AICA',
};

export const COMMENT_SOURCE_MAPPING = {
    Investors: 'LENDER',
    Partners: 'PARTNER',
    ASSESSEE: 'ASSESSEE',
};

export const DEAL_VIEW_TYPES = {
    DEAL_VIEW: 'DEAL_VIEW',
    MANDATE_VIEW: 'MANDATE_VIEW',
};
export const FROM_DEBT_OPTIONS_PARAM = 'fromDebtOptions';
export const STATUS_TYPE = {
    DEAL: 'DEAL',
    MANDATE: 'MANDATE',
};
export const DATA_POSITION = {
    REPORT: 'Report',
    COMPANY: 'Company',
};

export const MAGIC_UPLOAD_TYPE = {
    INDIVIDUAL: 'Individual',
    GLOBAL: 'Global',
};

export const REFRESH_UNLOCK_POS = {
    LOCKED_MODULE: 'Locked Module',
    UNLOCKED_BUTTON: 'Unlocked Button',
    THREE_DOT_MENU: '3-dot Menu',
    HEADER_REFRESH_ICON: 'Header Refresh Icon',
};

export const TEXT_EDITOR_TYPES = {
    ENGAGEMENT_LETTER: 'EngagementLetter',
    ONE_PAGER: 'OnePager',
    BUREAU_KYC_CONSENT: 'BureauKycConsent',
    NDA: 'NDA',
    APPLICATION_FORM: 'ApplicationForm',
};

export const FILE_FOLDER_TYPES = {
    FILE: 'File',
    FOLDER: 'Folder',
    SUB_FOLDER: 'Sub Folder',
};

export const DEAL_STATUS_COUNT_TYPES = {
    PENDING: 'Queries',
    RESOLVED: 'Resolved',
    NONE: 'None',
};

export const LEAD_VIEW_TYPE = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED',
} as const;

export const DEAL_COLUMN_KEYS = {
    ACTIONS: 'actions',
    LENDER_USERS: 'lenderUsers',
    DEAL_PROBABILITY: 'dealProbability',
};

// Deal-list columns whose cells stay interactive even on rows disabled via
// dealStatusConfig.overrideDisableRow (e.g. Passed deals). Add a column's
// field key here to keep its onClick reachable without re-enabling the rest
// of the row.
export const DEAL_COLUMNS_BYPASSING_ROW_DISABLE: string[] = [DEAL_COLUMN_KEYS.DEAL_PROBABILITY];

export const ENTITY_TYPES = {
    LEAD: 'Lead',
    DEAL: 'Deal',
    MANDATE: 'Mandate',
} as const;

export const DEAL_UPDATER_OWNER_TYPE = 'dealUpdater';

export const SET_PLATFORM_USER_DATA = 'SET_PLATFORM_USER_DATA';
export const FETCH_PLATFORM_USER_DETAILS = 'FETCH_PLATFORM_USER_DETAILS';

export const DEAL_SOURCE_TYPES = {
    DEAL: 'deal',
    INVESTOR_DEAL: 'investor-deal',
    DEBT_PRODUCTS: 'debtProducts',
    CREATE_DEAL: 'createDeal',
    EDIT_DEAL: 'editDeal',
    DEAL_FILTERS: 'DEAL_FILTERS',
    STATUS_TIMELINE: 'STATUS_TIMELINE',
} as const;

export const DEAL_CONFIG_SOURCES = [
    DEAL_SOURCE_TYPES.DEBT_PRODUCTS,
    DEAL_SOURCE_TYPES.CREATE_DEAL,
    DEAL_SOURCE_TYPES.EDIT_DEAL,
    DEAL_SOURCE_TYPES.DEAL_FILTERS,
    DEAL_SOURCE_TYPES.STATUS_TIMELINE,
] as const;

// Financial Headers Constants
export const CLASSIFICATION_NAME_KEY = 'classificationName';
export const PROVISIONAL_KEY = 'provisional';

export const filterFinancialHeadersWithoutClassificationName = (header: any) => header.key !== CLASSIFICATION_NAME_KEY;
export const isProvisionalHeader = (header: any) => header?.key === PROVISIONAL_KEY;

// Comment Field Name Constants
export const COMMENT_FIELD = 'comment';
export const COMPANY_COMMENT_FIELD = 'companyComment';

// GST Status Constants
export const GST_STATUS = {
    ACTIVE: 'ACTIVE',
    PROVISIONAL: 'PROVISIONAL',
    EXPIRED: 'EXPIRED',
    SUSPENDED: 'SUSPENDED',
    CANCELLED: 'CANCELLED',
    CANCELLED_SUO_MOTO: 'CANCELLED SUO-MOTO',
    INACTIVE: 'INACTIVE',
    CANCELLED_ON_REQUEST_OF_TAXPAYER: 'CANCELLED ON REQUEST OF TAXPAYER',
    CANCELLED_ON_APPLICATION_OF_TAXPAYER: 'CANCELLED ON APPLICATION OF TAXPAYER',
} as const;

export const PRIMARY_GST_STATUSES: string[] = [GST_STATUS.ACTIVE, GST_STATUS.PROVISIONAL, GST_STATUS.EXPIRED];

export const loansFetchStatus = {
    NOT_ABLE_TO_FETCH: 'NOT_ABLE_TO_FETCH',
    SUCCESS: 'SUCCESS',
    NO_DATA: 'NO_DATA',
};
